import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	recentlyViewedBoards: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.boards.recently-viewed-boards',
		defaultMessage: 'Recently Viewed Boards',
		description: 'Section title for recently viewed boards',
	},
});
